import React, {Component} from 'react';
import {observable, action, computed, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import * as util from '../../../util';

interface ICheckoutInputElementProps {
    o: IFormInput;
    ab: number;
    required?: boolean;
    type?: string;
    label?: string;
    autoFocus?: boolean;
    mask?: string;
    isMask?: boolean;
    hideSpinner?: boolean;
    placeholder?: string;
    places?: boolean;
    floating?: boolean;
    ariaLabel?: string;
    readOnly?: boolean;
    billing?: boolean;
    onChange?();
    onBlur?();
}

@observer
export class CheckoutInputElement extends React.Component<ICheckoutInputElementProps> {
    regEx: RegExp | null;
    throttle: number;
    hasBlurred: boolean;
    @observable isFocused: boolean;

    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.process = this.process.bind(this);
        makeObservable(this);
    }

    componentDidMount() {
        this.regEx = this.props.o.valid && this.props.o.valid.rgx && this.props.o.valid.rgx != undefined && this.props.o.valid.rgx.length > 0 ? new RegExp(this.props.o.valid.rgx, 'gi') : null;
        this.process(false);
    }

    @computed get isError() {
        return this.props.o.valid.alive && this.props.o.valid.isError;
    }

    @computed get showValid() {
        return this.props.o.valid.alive && !this.props.o.valid.isError;
    }

    @action
    onChange(e: React.ChangeEvent<HTMLInputElement>) {
        this.props.o.value = e.target.value;
        this.process(true);
    }

    @action
    onBlur(e: React.ChangeEvent<HTMLInputElement>) {
        this.isFocused = false;
        this.process(true, false, true);
        if (this.props.onBlur != undefined) {
            this.props.onBlur();
        }
    }

    @action
    process(emptyMeansInvalid: boolean, doChange: boolean = true, isBlur: boolean = false) {
        this.props.o.valid.isError = false;
        if (!this.props.o.value) {
            this.props.o.value = '';
        }
        if (!this.props.o.valid.alive === true && this.props.o.value && this.props.o.value.length > 0) {
            this.props.o.valid.alive = true;
        }

        // regex
        this.props.o.valid.msg = (!this.regEx || this.regEx === null ? false : !this.regEx.test(this.props.o.value)) ? this.props.o.valid.rgx_msg : '';

        // length
        if ((isBlur || this.props.o.valid.alive === true) && this.props.o.valid.msg.length < 1) {
            if (this.props.o.valid.minLength > 0 && this.props.o.value.length === 0) {
                this.props.o.valid.msg = `Please enter your ${this.props.o.placeholder.toLowerCase()}`;
            } else if (this.props.o.value.length < this.props.o.valid.minLength) {
                this.props.o.valid.msg = util.ValidationMessages.TooShort;
            } else if (this.props.o.value.length > this.props.o.valid.maxLength) {
                this.props.o.valid.msg = util.ValidationMessages.TooLong;
            }
        }

        if ((isBlur || this.props.o.valid.alive === true) && this.props.o.valid.msg.length > 0) {
            this.props.o.valid.isError = true;
        }

        if (!emptyMeansInvalid && this.props.o.value === '') {
            this.props.o.valid.isError = false;
            this.props.o.valid.alive = false;
            this.props.o.valid.msg = '';
        }

        if (doChange && this.props.onChange != undefined) {
            this.props.onChange();
        }
    }

    render() {
        if (this.props.floating) {
            return (
                <div className="form-floating mb-2">
                    {!this.props.isMask && (
                        <input
                            value={this.props.o.value}
                            onFocus={() => (this.isFocused = true)}
                            onBlur={this.onBlur}
                            onChange={this.onChange}
                            name={this.props.billing ? this.props.o.autocomplete.replace('shipping', 'billing') : this.props.o.autocomplete}
                            minLength={this.props.o.valid.minLength}
                            maxLength={this.props.o.valid.maxLength}
                            className={`form-control ${this.props.hideSpinner ? 'hide-input-spinner' : ''} ${this.props.o.valid.isError ? 'error' : this.showValid ? 'valid' : ''} ${this.props.places ? 'google-places' : ''}`}
                            aria-label={this.props.ariaLabel ? this.props.ariaLabel : this.props.o.placeholder}
                            placeholder={this.props.o.placeholder ? this.props.o.placeholder : ''}
                            type={this.props.type == undefined ? 'text' : this.props.type}
                            autoComplete={this.props.billing ? this.props.o.autocomplete.replace('shipping', 'billing') : this.props.o.autocomplete}
                            readOnly={this.props.readOnly ? true : false}
                            autoFocus={this.props.autoFocus ? true : false}
                        />
                    )}
                    <label className="form-label">
                        {this.props.o.placeholder}
                        {this.props.required ? '' : ''}
                    </label>

                    {this.props.o.valid.isError && <div className="input-error">{this.props.o.valid.msg}</div>}
                </div>
            );
        } else {
            return (
                <div className="input-element">
                    {this.props.ab < 0 && (
                        <div className={`${this.isFocused ? 'input-label input-label-focused' : 'input-label'}${this.props.places ? 'google-places' : ''}`}>
                            {this.props.required ? '* ' : ''}
                            {this.props.o.placeholder}
                            {this.props.required ? '' : <span className="optional">(Optional)</span>}
                        </div>
                    )}

                    {!this.props.isMask && (
                        <input
                            value={this.props.o.value}
                            onFocus={() => (this.isFocused = true)}
                            onBlur={this.onBlur}
                            onChange={this.onChange}
                            name={this.props.billing ? this.props.o.autocomplete.replace('shipping', 'billing') : this.props.o.autocomplete}
                            minLength={this.props.o.valid.minLength}
                            maxLength={this.props.o.valid.maxLength}
                            className={`form-control ${this.props.hideSpinner ? 'hide-input-spinner' : ''} ${this.props.o.valid.isError ? 'error' : this.showValid ? 'valid' : ''}`}
                            aria-label={this.props.ariaLabel ? this.props.ariaLabel : this.props.o.placeholder}
                            placeholder={this.props.o.placeholder ? this.props.o.placeholder : ''}
                            type={this.props.type == undefined ? 'text' : this.props.type}
                            autoComplete={this.props.billing ? this.props.o.autocomplete.replace('shipping', 'billing') : this.props.o.autocomplete}
                            readOnly={this.props.readOnly ? true : false}
                            autoFocus={this.props.autoFocus ? true : false}
                        />
                    )}

                    {this.props.o.valid.isError && <div className="input-error">{this.props.o.valid.msg}</div>}
                </div>
            );
        }
    }
}
